/** 教師工作 vo */
export class TeacherWork {

    teacherID :string 
    occurDate :Date
    constructor (){
       this.occurDate =new Date(); 
    }
    checkValue(){}

}